import SpectrumLogo from './SpectrumLogo';

export default SpectrumLogo;
